import { FieldValidator } from "../modules/form/store";

export const required = ({ name, value }, { values }): boolean => {
    if (typeof value === 'string') {
        return value.trim() !== '';
    }
    return value !== '' && value !== undefined && value !== null;
};

export const requiredNonZero = ({ name, value }, { values }): boolean => {
    return value !== '' && value !== undefined && value !== null && value !== 0;
};

export const validateOperatingTimeOrCount = (oldValue, newValue): { type, difference } | null => {
    if ((newValue < oldValue || newValue - 40 >= oldValue) && oldValue > 0) {
        if (newValue < oldValue) {
            return { type: 'underLimit', difference: oldValue - newValue };
        } else {
            return { type: 'overLimit', difference: newValue - oldValue };
        }
    }
    return null;
};

export const checkTimeNumberFormat = (event, currentValue) => {
    const charCode = event.charCode;

    const isDigit = charCode >= 48 && charCode <= 57;
    const isComma = charCode === 44;
    const isDot = charCode === 46;
  
    if (isDigit || isComma || isDot) {
      if (isComma && currentValue.includes(",")) {
        event.preventDefault(); // prevent double comma
        return;
      }

      if (isDot && currentValue.includes(".")) {
        event.preventDefault();
        return;
      }
  
      if (isDigit) {
        const decimalPart = (currentValue.includes(",")) ? (currentValue.split(",")[1] || "") : (currentValue.split(".")[1] || "");
  
        const input = event.target;
        const hasSelection =
          input &&
          typeof input.selectionStart === "number" &&
          typeof input.selectionEnd === "number" &&
          input.selectionStart !== input.selectionEnd;
  
        if (decimalPart.length >= 1 && !hasSelection) {
          event.preventDefault(); // prevent more than one digit after decimal
        }
      }
    } else {
      event.preventDefault(); // prevent non-digit, non-comma input
    }
};

export const requiredArray = ({ name, value }, { values }): boolean => {
    return value !== undefined && value !== null && value.length;
};

export const requiredBoolean = ({ name, value }, { values }): boolean => {
    return value !== undefined && value !== null && value !== false;
};

export const minValidator = (min: number): FieldValidator => (field) => {
    if (field.value === undefined || field.value === null || field.value === '') return true;
    if (typeof field.value !== 'number') return false;
    return field.value >= min;
};

export const maxValidator = (max: number): FieldValidator => (field) => {
    if (field.value === undefined || field.value === null || field.value === '') return true;
    if (typeof field.value !== 'number') return false;
    return field.value < max;
};